import { NotificationModule } from './../../../module/notification/notification.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavBarComponent } from './nav-bar.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../shared/component/shared.module';

@NgModule({
    declarations: [
        NavBarComponent
    ],
    exports: [
        NavBarComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        NotificationModule
    ]
})
export class NavBarModule { }
